module.exports = __webpack_public_path__ + "img/club-logo2.0debd247.png";